import { Navigate, Outlet } from "react-router-dom";
import { ShopLayout } from "@/components/ShopLayout";
import { useShopMe } from "@/lib/useShopMe";

export function RequirePermanentContract() {
  const { me, loading } = useShopMe();

  if (loading) {
    return (
      <ShopLayout>
        <div className="shop-page">
          <p className="text-sm text-slate-500">Wird geladen…</p>
        </div>
      </ShopLayout>
    );
  }

  if (!me?.permanent_contract) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
